/* eslint-disable import/prefer-default-export */
export const courseClassesPeriod = {
  MORNING: "Matutino",
  AFTERNOON: "Vespertino",
  EVENING: "Noturno",
  FULL_TIME: 'Integral'
};
